<!--课堂评估-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="te-page">
            <!--中心切换 Tab（当前仅一个：评估报告），查看详情时右侧显示返回按钮-->
            <div class="tab-row">
                <div v-for="t in tabs" :key="t.key"
                     :class="['tab-pill', activeTab === t.key ? 'tab-active' : '']"
                     @click="activeTab = t.key">{{ t.label }}</div>
                <div v-if="showDetail" class="back-btn" @click="backToList">
                    <el-icon><ArrowLeft /></el-icon>返回
                </div>
            </div>

            <!--评估报告-->
            <div class="panel" v-if="activeTab === 'report'">
                <!--报告详情（iframe）：显示时隐藏列表，加载期间显示 loading-->
                <div v-if="showDetail" class="detail-wrap" v-loading="reportLoading"
                     element-loading-text="报告加载中...">
                    <iframe class="report-iframe" :src="reportUrl" frameborder="0"
                            @load="reportLoading = false"></iframe>
                </div>

                <!--全屏按钮：查看报告时浮动在屏幕右侧中间，点击新标签页打开-->
                <div v-if="showDetail" class="fullscreen-btn" title="全屏查看评估报告" @click="openFullPage">
                    <el-icon><FullScreen /></el-icon>
                </div>

                <!--报告列表-->
                <div v-else class="list-scroll">
                    <!--空数据提示-->
                    <div v-if="dataList.length === 0" class="empty-tip">暂无评估报告数据</div>
                    <!--报告卡片列表-->
                    <div v-else class="report-list">
                        <div v-for="(item, index) in dataList" :key="index" class="report-card" @click="readReport(item)">
                            <!--标题行：视频名称 + 下载查看按钮（靠右）-->
                            <div class="card-header">
                                <div class="video-name">
                                    <span class="label">视频名称：</span>
                                    <span class="value">{{ item.fileName }}</span>
                                </div>
                                <div class="download-btn" @click.stop="readReport(item)">
                                    <span class="btn-text">查看报告</span>
                                </div>
                            </div>
                            <!--信息网格：授课教师、学段、学科、评估时间一行显示-->
                            <div class="info-grid">
                                <div class="info-item">
                                    <span class="label">授课教师：</span>
                                    <span class="value">{{ item.trueName }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="label">学段：</span>
                                    <span class="value">{{ item.periodName }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="label">学科：</span>
                                    <span class="value">{{ item.subjectName }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="label">评估时间：</span>
                                    <span class="value">{{ timestampToTime(item.createTime) || '暂无' }}</span>
                                </div>
                                <div class="info-item full-width">
                                    <span class="label">量表：</span>
                                    <span class="value">{{ item.scaleName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import homeHead from "@/components/homeHead.vue";
import {listUserReport} from "@/api/admin/courseAnalyse";
import {timestampToTime} from "@/utils/date";

export default {
    name: "homeTeachEvaluation",
    components: {
        homeHead
    },
    data() {
        return {
            activePath: "teachToolLink",
            /*当前Tab（仅一个：评估报告）*/
            activeTab: "report",
            tabs: [
                { key: 'report', label: '评估报告' },
            ],
            timestampToTime,
            dataList: [],
            /*报告详情（iframe）*/
            showDetail: false,
            reportUrl: '',
            reportLoading: false,
        }
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        this.getUserReportList();
    },
    methods: {
        /*查询评估报告列表*/
        getUserReportList() {
            listUserReport().then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        /*查看报告：taskType=1 教学实施报告，否则 有效课堂报告；本页 iframe 展示*/
        readReport(item) {
            const path = item.taskType === 1 ? '/jzedu/jxssReport' : '/jzedu/yxktReport';
            this.reportUrl = path + '?taskId=' + item.taskId;
            this.reportLoading = true;
            this.showDetail = true;
        },
        /*返回列表*/
        backToList() {
            this.showDetail = false;
            this.reportUrl = '';
            this.reportLoading = false;
        },
        /*新标签页打开报告（全屏查看）*/
        openFullPage() {
            if (this.reportUrl) {
                window.open(this.reportUrl, '_blank');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.te-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}

/*中心切换 Tab*/
.tab-row {
    display: flex;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}

.tab-pill {
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 16px;
    cursor: pointer;
}

.tab-active {
    background: #ff7f2e;
    border-color: #ff7f2e;
    color: #ffffff;
}

/*返回按钮：Tab 行靠右*/
.back-btn {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 20px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 15px;
    cursor: pointer;

    &:hover {
        background: #ff7f2e;
        border-color: #ff7f2e;
        color: #ffffff;
    }
}

/*全屏按钮：查看报告时浮动在屏幕右侧中间*/
.fullscreen-btn {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #ff7f2e;
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(13, 85, 164, 0.35);
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-50%) scale(1.08);
    }
}

/*蓝色面板*/
.panel {
    display: flex;
    flex-direction: column;
    max-width: 1840px;
    margin: 0 auto;
    background: #c9e5fc;
    border-radius: 28px;
    padding: 26px 28px 30px;
    box-sizing: border-box;
    height: calc(100vh - 182px);
    min-height: 0;
}

/*报告详情容器：占满列表区域*/
.detail-wrap {
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
}

/*报告详情 iframe*/
.report-iframe {
    flex: 1;
    min-height: 0;
    width: 100%;
    height: 100%;
    border: none;
}

/*列表滚动区域*/
.list-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 4px;
}

/*空数据提示*/
.empty-tip {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #8a97a8;
}

/*评估报告列表*/
.report-list {
    display: grid;
    gap: 20px;
}

/*报告卡片*/
.report-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 28px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    transition: transform .2s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 12px;

    &:hover {
        transform: translateY(-4px);
    }
}

/*卡片标题行：视频名称居左，下载按钮靠右*/
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid #f0f0f0;
}

.video-name {
    flex: 1;
    min-width: 0;
    font-size: 18px;
    line-height: 1.4;

    .value {
        color: #17365d;
        font-weight: 700;
    }
}

/*下载按钮*/
.download-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 18px;
    background-color: #f5f7fa;
    color: #6086c6;
    border-radius: 8px;
    font-size: 14px;
    border: 1px solid #e8edf5;
    transition: all .2s ease;

    &:hover {
        background-color: #e8edf5;
        color: #4a90e2;
        border-color: #d8e2f0;
    }
}

/*信息网格：一行四项*/
.info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px 24px;
}

/*信息项*/
.info-item {
    display: flex;
    font-size: 14px;
    line-height: 1.6;

    .label {
        flex-shrink: 0;
        color: #8a97a8;
    }

    .value {
        color: #333;
        font-weight: 500;
        word-break: break-all;
    }
}

/*量表独占一行*/
.full-width {
    grid-column: 1 / -1;
}

/*响应式适配*/
@media screen and (max-width: 768px) {
    .info-grid {
        grid-template-columns: 1fr;
    }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
    .info-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/*矮屏紧凑适配*/
@media screen and (max-height: 800px) {
    .panel {
        padding: 18px 22px 22px;
    }

    .report-card {
        padding: 18px 22px;
    }
}
</style>
